import React, { useEffect, useState } from "react";
import DashboardPageTitle from "../../../component/DashboardPageTitle";
import { Box, Pagination, PaginationItem, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from "@mui/material";
import styles from "../../../layout/adminlayout/styles";
import theme from "../../../theme/Theme";
import DashboardLoader from "../../../component/DashboardLoader";
import { fetchDrawList } from "../../../api/ApiService";
import {  ticketDateFormat } from "../../../utils/common";
import { Link } from "react-router-dom";


const AdminDraws = () => {
    const [draws, setDraws] = useState([]);
    const [loading, setLoading] = useState(false);
    const [searchAddress, setSearchAddress] = useState("");
    const [originalDraws, setOriginalDraws] = useState([]);
  
    const [page, setPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(15);
    const fetchData = async () => {
        setLoading(true);
        try {
          const response = await fetchDrawList();
          if (response && response.data) {
            const drawListArray = response.data;
            setOriginalDraws(drawListArray);
            setDraws(drawListArray);
          }
        } catch (error) {
          console.error("Error fetching draws data:", error);
        } finally {
          setLoading(false);
        }
      };
    
      useEffect(() => {
        fetchData();
      }, []);
      const getStatus = (status, endTime) => {
        const isExpired = new Date(endTime) < new Date();
        switch (status) {
          case 1:
            return isExpired ? "Expired" : "Yet to Start";
          case 2:
            return isExpired ? "Expired" : "Started";
          case 3:
            return "Lottery Ended";
          case 4:
            return "Winners Count Defined";
          case 5:
            return "Winners Defined";
          case 6:
            return "Awards Distributed";
          default:
            return "Unknown Status";
        }
      };
    
      const handleSearchChange = (e) => {
        if (e.target.value === "") {
          setDraws(originalDraws);
        } else {
          const filterData = originalDraws.filter((draw) => {
            const combinedFields = `
            ${draw.drawId?.toLowerCase() || ""}
            ${draw.drawName?.toLowerCase() || ""}
            ${draw.ticketPrice?.toString().toLowerCase() || ""}
            ${draw.currencyTicker?.toLowerCase() || ""}
            ${draw.participantCount?.toString().toLowerCase() || ""}
            ${getStatus(draw.status , draw.endTime)?.toLowerCase() || ""}
            ${ticketDateFormat(draw.endTime)?.toLowerCase() || ""}
          `;
            return combinedFields.includes(e.target.value.toLowerCase());
          });
          setDraws(filterData);
        }
        setSearchAddress(e.target.value);
      };
    
    
      const handleChangePage = (event, newPage) => {
        setPage(newPage);
      };
    
    
      const rowsToDisplay = draws.slice(
        (page - 1) * rowsPerPage,
        page * rowsPerPage
      );
    return( <Box>
        <DashboardPageTitle title={"Draws List"} />
        <TextField
        size="small"
        variant="outlined"
        placeholder="Search Any Field"
        sx={{ mb: 2, width: "30%" ,mt: 3,}}
        value={searchAddress}
        slotProps={{
          input: {
            style: {
              fontSize: "0.8rem",
              fontWeight: 500,
              color: theme.custom.emperor,
            },
          },
        }}
        onChange={(e) => handleSearchChange(e)}
      />
        <TableContainer component={Paper} sx={styles.tableBackground}>
            <Table size="small">
                <TableHead>
                    <TableRow sx={{backgroundColor: theme.custom.tableHeaderBg}}>
                        <TableCell sx={styles.ticketTitleStyle}>ID</TableCell>
                        <TableCell sx={styles.ticketTitleStyle}>Draw Name</TableCell>
                        <TableCell sx={styles.ticketTitleStyle}>Ticket Price</TableCell>
                        <TableCell sx={styles.ticketTitleStyle}>Currency</TableCell>
                        <TableCell sx={styles.ticketTitleStyle}>Participant Count</TableCell>
                        <TableCell sx={styles.ticketTitleStyle}>Status</TableCell>
                        <TableCell sx={styles.ticketTitleStyle}>End Time(GMT 00:00)</TableCell>
                    </TableRow>
                </TableHead>

                <TableBody>
                    {loading ? (
                        <TableRow>
                            <TableCell colSpan={6}>
                                <DashboardLoader isLoading={loading} />
                            </TableCell>
                        </TableRow>
                    ) : rowsToDisplay.length > 0 ? (
                        
                    
                        rowsToDisplay.map((draw, index) => (
                            <TableRow key={index}
                            sx={{
                                backgroundColor:
                                  index % 2 !== 0 ? "#f3f3f3" : "transparent",
                              }}>
                                <TableCell sx={styles.ticketValueTitleStyle}>{draw.drawId}</TableCell>
                                <TableCell sx={styles.ticketValueTitleStyle}><Link to={`/admin/draws/${draw.drawId}`} style={{ textDecoration: "none", color: theme.custom.link }}>
                      {draw.drawName}
                    </Link></TableCell>
                                <TableCell sx={styles.ticketValueTitleStyle}>{draw.ticketPrice}</TableCell>
                                <TableCell sx={styles.ticketValueTitleStyle}>{draw.currencyTicker}</TableCell>
                                <TableCell sx={styles.ticketValueTitleStyle}>{draw.participantCount}</TableCell>
                                <TableCell sx={styles.ticketValueTitleStyle}>{getStatus(draw.status, draw.endTime)}</TableCell>
                                <TableCell sx={styles.ticketValueTitleStyle}>{ticketDateFormat(draw.endTime)}</TableCell>
                            </TableRow>
                        ))
                    ):(
                        <TableRow>
                            <TableCell colSpan={7} align="center">
                                <Typography sx={styles.ticketValueTitleStyle}>
                                    No Draws Found
                                </Typography>
                            </TableCell>
                        </TableRow>
                    )
                    }
                </TableBody>
                </Table>

        </TableContainer>


        <Box display="flex" justifyContent="center" mt={2}>
        <Pagination
            count={Math.ceil(draws.length / rowsPerPage)}
            shape="rounded"
            size="large"
            sx={styles.pagination}
            onChange={handleChangePage}
            renderItem={(item) => (
              <PaginationItem
                {...item}
                sx={{
                  backgroundColor: item.selected
                    ? theme.custom.white
                    : theme.palette.primary.main,
                  borderColor: item.selected
                    ? theme.palette.primary.main
                    : theme.custom.white,
                  borderWidth: item.selected ? "2px" : "1px",
                  borderRadius: "12px",
                  color: item.selected
                    ? theme.palette.primary.main
                    : theme.custom.white,
                  "&:hover": {
                    backgroundColor: theme.palette.primary.main,
                  },
                  ...(item.type === "previous" || item.type === "next"
                    ? {
                      backgroundColor: "transparent",
                      color: theme.palette.primary.main,
                      borderRadius: "12px",
                      "&:hover": {
                        backgroundColor: "rgba(255, 162, 156, 0.7)",
                        color: theme.palette.primary.main,
                      },
                    }
                    : {}),
                }}
              />
            )}
          />
      </Box>

    </Box>
)}
export default AdminDraws;